import { CircularProgress, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { getScheduleNotification, cancelscheduleNotification, getRecipientsByScheduleId } from 'src/helper/backend_helper';
import ActivityLogsTable from './activitylogsTable';

export interface ScheduleActivitySource {
  key: string;
  list: () => Promise<any>;
  cancel: (id: number) => Promise<any>;
  recipients: (id: number) => Promise<any>;
}
const legacySource: ScheduleActivitySource = {
  key: 'legacy-schedules', list: getScheduleNotification,
  cancel: cancelscheduleNotification, recipients: getRecipientsByScheduleId
};
export default function ActivityLogsData({ dataSource = legacySource }: { dataSource?: ScheduleActivitySource }) {
  const query = useQuery([dataSource.key], dataSource.list, { keepPreviousData: false });
  if (query.isLoading) return <CircularProgress size={24} />;
  if (query.isError) return <Typography color="error">Failed to load scheduled activity.</Typography>;
  const schedules = query.data?.data?.data ?? [];
  const activityLogs = schedules.flatMap((row) => [
    { id: `${row.id}:created`, title: row.ownership === 'LEGACY_UNKNOWN' ? 'Legacy schedule recorded' : 'Notification scheduled',
      description: `${row.title} — ${new Date(row.createdAt).toLocaleString()}${row.ownership === 'LEGACY_UNKNOWN' ? ' (ownership and final outcome unverified)' : ''}` },
    ...(row.emailSentAt ? [{ id: `${row.id}:email-sent`, title: 'Reminder email sent', description: `${row.title} — ${new Date(row.emailSentAt).toLocaleString()}` }] : []),
    ...(row.sentAt ? [{ id: `${row.id}:sent`, title: 'Notification sent', description: `${row.title} — ${new Date(row.sentAt).toLocaleString()}` }] : []),
    ...(row.cancelledAt ? [{ id: `${row.id}:cancelled`, title: 'Notification cancelled', description: `${row.title} — ${new Date(row.cancelledAt).toLocaleString()}` }] : [])
  ]);
  return <ActivityLogsTable activityLogs={activityLogs} schedules={schedules} dataSource={dataSource} refresh={() => query.refetch()} />;
}
